import React, {useEffect, useState} from "react";
import _ from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {
  clearComponentLoading,
  resetAlert,
  setAlertError,
  setAlertSuccess,
  setComponentLoading,
} from "../../store/actions";
import {TEMPLATE_MANAGEMENT} from "../../constants/routes";
import {useDocumentTitle, useTemplate} from "../../hooks";
import {getTemplates, updateTemplate} from "../../services/TemplateServices";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import {
  ButtonAdd,
  ButtonReset,
  ButtonUpdate,
  ButtonFilter,
  CheckboxInput,
  FormGroup,
  Label,
  PageTitle,
  SelectInput,
  TextInput,
  Button,
  ButtonDPad,
  RedirectAlert
} from "../../components";
import {getFormErrorResponseData, hasErrorInput} from "../../utils";
import {errorStatusHandle} from "../../utils";
import BackendLayout from "../../layouts/BackendLayout";
import PageAlert from "../../components/alerts/PageAlert";
import Table from "../../components/table/Table";
import Pagination from "../../components/Pagination";
import ModalAddNewTemplate from "../../components/template-management/ModalAddNewTemplate";
import ConfirmModal from "../../components/ConfirmModal";
import Select2 from "../../components/Select2";
import SortArrow from "../../components/SortArrow";
import {
  getChildGroupOptionConfig,
  getSelectedOption,
  getSelectLabel,
  hasErrors
} from "../../utils/group-option-utils";
import * as ArrayUtils from "../../utils/array-utils";
import { FiClipboard } from "react-icons/fi"
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import { setButtonProcessing, clearButtonProcessing } from "../../store/actions";
import { handleOnBeforeUnload } from "../../utils/common-utils";
import { USER_SETTING_CATEGORIES } from "../../constants/app";
import { updateUserSetting} from "../../services/user-master/UserSettingServices"
import useRedirectPage from "../../hooks/useRedirectPage";
import {TEMPLATE_MANAGEMENT_PAGE} from "../../constants/pageName";
import Toggle from "../../components/form/inputs/Toggle";

export default function TemplateManagement() {
  useRedirectPage(TEMPLATE_MANAGEMENT_PAGE);
  useDocumentTitle("点検テンプレートマスタ更新 - 点検王");
  const breadcrumb = getRouteBreadcrumb(TEMPLATE_MANAGEMENT);
  const dispatch = useDispatch();
  const groupSettings = useSelector((state) => state.app_settings.machine_group);
  const [buttonSearchId, setButtonSearchId] = useState('');
  const {templates, machines, groupsList, groupsChildren, conditions, setConditions, filterValue, setFilterValues} = useTemplate(buttonSearchId);

  const [tableData, setTableData] = useState(templates);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedData, setPaginatedData] = useState([]);

  const [openModalAddTemplate, setOpenModalAddTemplate] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const settingData = {
    groupsChildren: groupsChildren,
    machines: machines,
    groupsList: groupsList
  };
  const [newTemplate, setNewTemplate] = useState({});

  const initialDataUpdate = {"templates": {}, "delete_template_ids": []};
  const [dataUpdate, setDataUpdate] = useState(initialDataUpdate);
  const [hasChange, setHasChange] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const OPTION_NO_SPECIFY = {value: "", label: "[ALL]"};
  const OPTION_ALL = {value: "", label:'[ALL]'};
  const [groupsOptions, setGroupOptions] = useState({});
  const [tableGroupsOptions, setTableGroupOptions] = useState({});

  useEffect(() => {
    let groupCombine = {1: filterValue.group_1, 2: filterValue.group_2, 3: filterValue.group_3, 4: filterValue.group_4, 5: filterValue.group_5,};
    const options = getChildGroupOptionConfig(groupsChildren, groupCombine, groupsList, machines, true);
    setGroupOptions(options);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, groupsChildren, groupsList]);

  useEffect(() => {
    let options = [];
    tableData.forEach((row, idx) => {
      let groupCombine = {
        1: row.group_1 && row.group_1.id,
        2: row.group_2 && row.group_2.id,
        3: row.group_3 && row.group_3.id,
        4: row.group_4 && row.group_4.id,
        5: row.group_5 && row.group_5.id,
        machine: row.machine && row.machine.id
      };
      options[row.id] = getChildGroupOptionConfig(groupsChildren, groupCombine, groupsList, machines);
    });
    setTableGroupOptions(options);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData, paginatedData, groupsChildren, groupsList]);

  // Function to handle changes input fields
  const onChange = (event) => {
    dispatch(resetAlert());
    const {name, value} = event.target;
    setFilterValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const updateSettings = async () => {
    try {
      const { name, ...formatFilterValue} = filterValue;
      // eslint-disable-next-line no-unused-vars
      const response = await updateUserSetting(formatFilterValue, USER_SETTING_CATEGORIES.TEMPLATE_MANAGEMENT);
    } catch (e) {
      errorStatusHandle(e);
    }
  };

  const onSelectChange = (e, fieldName) => {
    dispatch(resetAlert());
    setFilterValues((preValue) => {
      const updatedData = {...preValue};
      if (e === null) {
        updatedData[fieldName] = null;
      } else {
        updatedData[fieldName] = e ? e.value : null;
      }
      if (fieldName.startsWith("group")) {
        let x = fieldName.split("_").pop();
        x = 1 + parseInt(x);
        for (x; x <= 5; x++) {
          updatedData["group_" + x] = "";
        }
        updatedData["machine_id"] = "";
      }
      return updatedData;
    });
  };

  // Function help filter template data
  const filterTemplate = (e, buttonId) => {
    dispatch(resetAlert());
    e.preventDefault();
    setButtonSearchId(buttonId);
    setConditions({...filterValue});
  }

  useEffect(() => {
    setTableData(templates);
  }, [templates]);

  useEffect(() => {
    setTableData((prevState => [...prevState, newTemplate]));
  }, [newTemplate]);

  useEffect(() => {
    if (!hasChange) return;
    window.addEventListener('beforeunload', handleOnBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleOnBeforeUnload);
    }
  }, [hasChange]);

  // Pagination
  useEffect(() => {
    var paginated = [];
    if (tableData.length) {
      paginated = tableData.slice((currentPage -1) * pageSize, currentPage * pageSize);
    }
    setPaginatedData(paginated);
  }, [tableData, currentPage, pageSize]);

  // Handle sort data table
  const [sortOrderList, setSortOrderList] = useState([]);
  useEffect(() => {
    const columnsToSort = sortOrderList.map((order) => order.column);
    const orders = sortOrderList.map((order) => order.order.toLowerCase());
    const sortedTable = _.orderBy([...tableData], columnsToSort, orders);
    setTableData(sortedTable);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortOrderList]);

  const [order, setOrder] = useState({name: 0});
  function handleSortColumn(columnSort) {
    const isColumnSorted = sortOrderList.some((col) => col.column === columnSort);
    if (isColumnSorted) {
      // If the column is already sorted, update the sort order for that column
      const updatedSortOrderList = sortOrderList.map((col) =>
        col.column === columnSort ? {column: col.column, order: col.order === "asc" ? "desc" : ""} : col
      );
      setSortOrderList(
        updatedSortOrderList.filter((item) => item.order !== "")
      ); // Remove items with an empty order
    } else {
      // If the column is not sorted, add it to the sort order list
      const updatedSortOrderList = [
        ...sortOrderList,
        {column: columnSort, order: "asc"},
      ];
      setSortOrderList(updatedSortOrderList);
    }
    let currentOrder = order[columnSort];
    if (currentOrder === 0) {
      currentOrder = 1;
    } else if (currentOrder === 1) {
      currentOrder = -1;
    } else {
      currentOrder = 0;
    }
    setOrder({
      ...order,
      [columnSort]: currentOrder,
    });
  }

  // Function help change value input
  function handleInputChange(fieldName, value, row, index) {
    setErrorMessages([]);
    if (fieldName === 'status') {
      value = value == true ? 1 : 0;
    }
    setTemplateUpdateData(value, fieldName, row.id);
    setPaginatedData((prevPaginatedData) => {
      const updatedTableData = [...prevPaginatedData];
      updatedTableData[index][fieldName] = value;
      return updatedTableData;
    });
  }

  // Function help change option select in table form
  function onTableSelectChange(e, index, fieldName, id) {
    setErrorMessages([]);
    var value;
    if (fieldName === 'machine_id') {
      value = e ? e.value : '';
    } else {
      value = e.target.value;
    }
    setPaginatedData((prevData) => {
      const newData = [...prevData];
      if (fieldName === 'machine_id') {
        if (newData[index].machine === null) {
          newData[index].machine = {id: value};
        } else {
          newData[index].machine.id = value;
        }
      } else {
        if (newData[index][fieldName] === null) {
          newData[index][fieldName] = {id: value};
        } else {
          newData[index][fieldName].id = value;
        }
        let x = fieldName.split("_").pop();
        x = 1 + parseInt(x);
        for (x; x <= 5; x++) {
          if (newData[index]["group_" + x] === null) {
            newData[index]["group_" + x] = {id: ""};
          } else {
            newData[index]["group_" + x].id = "";
          }
        }
        if (newData[index].machine === null) {
          newData[index].machine = {id: ""};
        } else {
          newData[index].machine.id = "";
        }
      }
      return newData;
    });
    setTemplateUpdateData(value, fieldName, id);
  }

  // Function help change input checkbox
  const handleChangeCheckbox = (e, index, fieldName, id) => {
    setErrorMessages([]);
    setDataUpdate((prevData) => {
      const isExistsDeletedId = prevData.delete_template_ids.indexOf(id.toString());
      if (isExistsDeletedId !== -1) {
        return {...prevData, delete_template_ids: prevData.delete_template_ids.filter(item => (item !== id.toString()))};
      }
      return {...prevData, delete_template_ids: [...prevData.delete_template_ids, id.toString()]};
    });

    setPaginatedData((prevPaginatedData) => {
      const updatedTableData = [...prevPaginatedData];
      updatedTableData[index][fieldName] = e.target.checked;
      return updatedTableData;
    });
  };

  // Function help set data update table
  function setTemplateUpdateData(value, fieldName, id) {
    setHasChange(true);
    let templateUpdate;
    setDataUpdate((prevData) => {
      if (prevData.templates.hasOwnProperty(id)) {
        if (fieldName.startsWith("group")) {
          let x = fieldName.split("_").pop();
          let group_update = {}
          group_update[fieldName] = value.toString();
          x = 1 + parseInt(x);
          for (x; x <= 5; x++) {
            group_update["group_" + x] = "";
          }
          group_update["machine_id"] = "";
          templateUpdate = { ...prevData.templates, [id]: { ...prevData.templates[id], ...group_update }};
        } else {
          templateUpdate = { ...prevData.templates, [id]: { ...prevData.templates[id], [fieldName]: value.toString() }};
        }
      } else {
        let group_update = {};
        const obj = paginatedData.find((item) => item.id === id);
        if (fieldName.startsWith("group")) {
          let x = fieldName.split("_").pop();
          group_update[fieldName] = value.toString();
          x = parseInt(x);
          for (let i = 1; i <= 5; i++) {
            if (groupSettings["group_" + i].active) {
              if (i < x) {
                if (obj["group_" + i] === null) {
                  group_update["group_" + i] = "";
                } else {
                  group_update["group_" + i] = obj["group_" + i].id.toString();
                }
              } else if (i === x) {
                group_update["group_" + i] = value.toString();
              } else {
                group_update["group_" + i] = "";
              }
            }
          }
          group_update["machine_id"] = "";
        } else {
          group_update[fieldName] = value.toString();
          for (let i = 1; i <= 5; i++) {
            if (groupSettings["group_" + i].active) {
              if (obj["group_" + i] === null) {
                group_update["group_" + i] = "";
              } else {
                group_update["group_" + i] = obj["group_" + i].id.toString();
              }
            }
          }
        }
        templateUpdate = {...prevData.templates, [id]: group_update};
      }
      return {...prevData, templates: templateUpdate};
    });
  }

  // Check form table has change
  const hasChangeTable = () => {
    const isExistsDeleteIds = dataUpdate.delete_template_ids.length > 0;
    const isExistsDataUpdate = Object.keys(dataUpdate.templates).length > 0;
    return isExistsDataUpdate || isExistsDeleteIds;
  };

  // Function handle reset page
  const resetPage = () => {
    if (hasChangeTable()) {
      setHasChange(false);
      setOpenConfirmModal(true);
    } else {
      window.location.reload();
    }
  }

  // Function handle update data
  const update = async (e, buttonId) => {
    e.preventDefault();
    dispatch(setButtonProcessing(buttonId));
    dispatch(resetAlert());
    dispatch(setComponentLoading("template-management"));
    await updateTemplate(dataUpdate).then(
      (response) => {
        setErrorMessages([]);
        if (response.success === true) {
          setDataUpdate(initialDataUpdate);
          setAlertSuccessMessages(response.message);
        }
        setHasChange(false);
        const searchParams = {};
        Object.keys(conditions).forEach(key => {
          if (Array.isArray(conditions[key])) {
            searchParams[key] = conditions[key].join(',');
          } else {
            searchParams[key] = conditions[key];
          }
        });
        getTemplates(searchParams).then((templates) => {
          setTableData(templates);
        });
        dispatch(clearComponentLoading("template-management"));
      }
    ).catch(e => {
      errorStatusHandle(e.response);
      if (e.response.status === 400) {
        let errorResponse = getFormErrorResponseData(e);
        if (errorResponse) {
          setErrorMessages(errorResponse);
          setAlertErrorMessages(errorResponse);
        }
      }
      dispatch(clearComponentLoading("template-management"));
    }).finally(() => {
      dispatch(clearButtonProcessing(buttonId));
    });
  }

  const setAlertSuccessMessages = (successMessage) => {
    if (!_.isArray(successMessage)) {
      dispatch(setAlertSuccess(successMessage));
    }
    const items = [];
    if (!_.isEmpty(successMessage)) {
      let messages = new Set();
      for (const key in successMessage) {
        const content = successMessage[key];
        messages.add("・" + content);
      }
      messages = Array.from(messages);
      if (messages.length > 0) {
        items.push(...messages);
      }
    }
    dispatch(setAlertSuccess(items));
  };

  const setAlertErrorMessages = (response) => {
    const errorItems = [];
    if (!_.isEmpty(response.error_message)) {
      errorItems.push(response.error_message);
    }
    if (!_.isEmpty(response.errors)) {
      const errors = response.errors;
      let messages = new Set();
      for (const key in errors) {
        const errs = errors[key];
        if (typeof errs === 'string') {
          messages.add("・" + errs);
        } else {
          for (const errKey in errs) {
            messages.add("・" + errs[errKey]);
          }
        }
      }
      messages = Array.from(messages);
      if (messages.length > 0) {
        errorItems.push(...messages);
      }
    }
    dispatch(setAlertError(errorItems));
  };

  const handleFilter = (e) => {
    filterTemplate(e, 'search-template');
    updateSettings();
  };

  return (
    <BackendLayout breadcrumb={breadcrumb} sidebar={true}>
      <PageTitle title="点検テンプレートマスタ更新"/>
      <ButtonDPad />
      <div className="grid py-[4px] max-w-[1460px]">
        <RedirectAlert />
        <PageAlert />
        <div className="">
          <div className="template__form">
            <p className="font-light px-[16px]">条件を選択してください</p>
            <form className="flex w-fit" method="GET">
              <FormGroup direction="vertical" className="template-items">
                <Label text="点検テンプレート名" htmlFor="name"  className="mb-[4px]"/>
                <TextInput name="name" id="name" placeholder="点検テンプレートの名前..."
                           value={filterValue['name'] || ""}
                           className="template-management__input"
                           onChange={(e) => onChange(e)} maxLength={50} />
              </FormGroup>
              {ArrayUtils.range(1, 5).map((i, idx) =>
                groupSettings[`group_${i}`]?.active && (
                  <FormGroup direction="vertical" className="template-items w-fit" key={idx}>
                    <Label text={groupSettings[`group_${i}`].name} htmlFor={`group_${i}`} className="mb-[4px] whitespace-nowrap" />
                    <Select2 className="template-management__select"
                             classNamePrefix="react-select"
                             isClearable={false}
                             options={groupsOptions[i] || []}
                             value={getSelectedOption(groupsOptions[i], filterValue[`group_${i}`], OPTION_ALL)}
                             name={`group_${i}`}
                             onChange={(e) => onSelectChange(e, `group_${i}`)} />
                  </FormGroup>
                )
              )}
              <FormGroup direction="vertical" className="template-items">
                <Label text={groupSettings.machine?.name} htmlFor="machine_id" className="mb-[4px]"/>
                <Select2 className="template-management__select"
                         classNamePrefix="react-select"
                         options={groupsOptions?.machines || []}
                         isClearable={false}
                         value={getSelectedOption(groupsOptions?.machines, filterValue['machine_id'], OPTION_ALL)}
                         name="machine_id"
                         maxLength={200}
                         onChange={(e) => onSelectChange(e, 'machine_id')} />
              </FormGroup>

              <FormGroup direction="vertical" className="template-items pr-4">
                <Label className="h-[28px]"/>
                <ButtonFilter onClick={(e) => handleFilter(e)} id="search-template" />
              </FormGroup>
            </form>
          </div>

          <div className="template-management__table mr-4">
            <Table striped>
              <Table.Head>
                <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base">
                  <div className="flex items-center whitespace-nowrap">
                    点検テンプレート名
                    <SortArrow
                      order={order.name}
                      onChangeOrder={() => handleSortColumn("name")}
                    />
                  </div>
                </Table.HeadCell>
                {ArrayUtils.range(1, 5).map((i, idx) =>
                  groupSettings[`group_${i}`]?.active && (
                    <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base" key={idx}>
                      <div className="flex items-center whitespace-nowrap">
                        {groupSettings[`group_${i}`]?.name}
                      </div>
                    </Table.HeadCell>
                  )
                )}
                <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base">
                  <div className="flex items-center whitespace-nowrap normal-case">{groupSettings.machine?.name}</div>
                </Table.HeadCell>
                <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base">
                  <div className="flex items-center whitespace-nowrap normal-case">点検項目編集</div>
                </Table.HeadCell>
                <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base">
                  <div className="flex items-center whitespace-nowrap normal-case">状態</div>
                </Table.HeadCell>
                <Table.HeadCell className="bg-tenken-gray-300 text-tenken-tablet-regular xl:text-base">
                  <div className="flex items-center whitespace-nowrap normal-case">削除</div>
                </Table.HeadCell>
              </Table.Head>
              <Table.Body className="text-base">
                <LoadingSpinner component="template-management" />
                {paginatedData.map((row, index) => (
                  <Table.Row key={index} className={row.delete ? "!bg-[#FFE7E7]" : ""}>
                    <Table.Cell className="px-4 py-2 xl:px-6 xl:py-4">
                      <div className="flex items-center whitespace-nowrap">
                        <TextInput name={`name_${index}`} id={`name_${index}`}
                                   disabled={!row.status}
                                   value={row.name || ""} maxLength={50}
                                   className="template-management__input"
                                   hasError={hasErrorInput(errorMessages.errors, "name[" + row.id + "]")}
                                   onChange={(e) => handleInputChange("name", e.target.value, row, index)} />
                      </div>
                    </Table.Cell>
                    {ArrayUtils.range(1, 5).map((i, idx) =>
                      groupSettings[`group_${i}`]?.active && (
                        <Table.Cell className="template-items px-4 py-2 xl:px-6 xl:py-4" key={idx}>
                          <div className="flex items-center whitespace-nowrap">
                            <SelectInput options={tableGroupsOptions[row.id]?.[i]}
                                         name={`group_${i}_${index}`}
                                         disabled={!!row?.is_using || !row.status}
                                         className='template-management__select truncate appearance-none !pr-[20px]'
                                         hasError={hasErrors([`group_${i}[` + row.id + "]", "group_error[" + row.id + "]"], errorMessages.errors)}
                                         value={row[`group_${i}`]?.id ? parseInt(row[`group_${i}`]?.id) : 0}
                                         onChange={(e) => onTableSelectChange(e, index, `group_${i}`, row.id)} />
                          </div>
                        </Table.Cell>
                      )
                    )}
                    <Table.Cell className="template-items px-4 py-2 xl:px-6 xl:py-4">
                      <div className="flex items-center whitespace-nowrap">
                        <Select2 className="template-management__select"
                                 classNamePrefix="react-select"
                                 options={tableGroupsOptions[row.id]?.machines}
                                 isClearable={false}
                                 isDisabled={!!row?.is_using || !row.status}
                                 hasError={hasErrors(["machine_id[" + row.id + "]"], errorMessages.errors)}
                                 value={
                                   (row.machine && row.machine.id) ?
                                   {value: row.machine.id, label: getSelectLabel(tableGroupsOptions[row.id]?.machines, row.machine.id)}
                                   : OPTION_NO_SPECIFY
                                 }
                                 name={`machine_${index}`}
                                 maxLength={200}
                                 onChange={(e) => onTableSelectChange(e, index, "machine_id", row.id)} />
                      </div>
                    </Table.Cell>
                    <Table.Cell className="template-items px-4 py-2 xl:px-6 xl:py-4">
                      <Link to={`/edit-inspection-item/${row.id}`}>
                        <Button color="yellow" className="min-w-[140px]" disabled={!row.status}>
                          <FiClipboard className="mr-[4px]" size={20} />
                          点検項目編集
                        </Button>
                      </Link>
                    </Table.Cell>
                    <Table.Cell className="template-items px-4 py-2 xl:px-6 xl:py-4">
                      <Toggle onClick={handleInputChange}
                              checked={row.status}
                              name='status'
                              idx={index}
                              row={row} />
                    </Table.Cell>
                    <Table.Cell className="template-items px-4 py-2 xl:px-6 xl:py-4">
                      <div className="flex items-center whitespace-nowrap justify-center">
                        <CheckboxInput name="delete"
                                       value={`template_${row.id}`}
                                       checked={row.delete || false}
                                       className="border-gray-500"
                                       onChange={(e) => handleChangeCheckbox(e, index, "delete", row.id)} />
                      </div>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
        </div>
        <div className={`pt-[16px] ${(Object.keys(conditions).length === 0 || tableData.length > 0) ? 'hidden' : ''}`}>
          <p>該当する検索結果が見つかりませんでした。別の検索条件をお試しください。</p>
        </div>
        <div className="lg:flex mr-4">
          <div className="md:mt-3 xl:mt-6 mr-4">
            <ButtonAdd className="w-[220px]" onClick={(e) => { setOpenModalAddTemplate(true) }}>
              点検テンプレート作成
            </ButtonAdd>
          </div>
          <div className={`md:mt-3 xl:mt-6 w-full`}>
            <Pagination showIndex={tableData.length > 0}
                        setPage={setCurrentPage}
                        currentPage={currentPage}
                        setPageSize={tableData.length > 0 ? setPageSize : null}
                        pageSize={pageSize}
                        numPages={Math.ceil(tableData.length / pageSize)}
                        totalCount={tableData.length} />
          </div>
        </div>
      </div>
      <div className="machine-update__btn--group">
        <ButtonReset onClick={resetPage} className="md:mr-[80px] lg:mr-[160px] lg:min-w-[280px] min-w-[240px]"/>
        <ButtonUpdate onClick={(e) => update(e, 'update-template')}
                      className="lg:min-w-[280px] min-w-[240px]"
                      disabled={!hasChangeTable()} id="update-template">
          <span>適用</span>
        </ButtonUpdate>
      </div>
      <ModalAddNewTemplate openModal={openModalAddTemplate}
                           setOpenModal={setOpenModalAddTemplate}
                           settingData={settingData}
                           setNewTemplate={setNewTemplate} />
      <ConfirmModal openModal={openConfirmModal}
                    setOpenModal={setOpenConfirmModal}
                    onConfirm={() => window.location.href = TEMPLATE_MANAGEMENT}
                    setHasChanged={setHasChange}/>
    </BackendLayout>
  );
}
